import {
  Box,
  Button,
  Checkbox,
  ClickAwayListener,
  Icon,
  ListItemText,
  MenuItem,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { CategoryHierarchy } from "@Interfaces/Api/category";
import { useEffect, useState } from "react";
import { apiCategories } from "@Services/API/IndividualApi's/Category";
import { useRouter } from "next/router";
import { apiProduct } from "@Services/API/IndividualApi's/Products";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import ClearIcon from "@mui/icons-material/Clear";
import { StyledLightGreenButton } from "@Styled/Common";
import {
  DropDownContainer,
  FilterContainer,
  StyledCategoryFilterContainer,
  StyledGrayBox,
} from "@Styled/Pages/Category";
import { theme } from "@Definitions/Styled";
import MainHeading from "@Components/Basic/MainHeading";
import CategoryBreadcrumb from "@Components/Basic/Breadcrumb";
import { StyledHeadingWithGradientunderline } from "@Styled/Pages/Landing/Category";

export interface ICategoryFilterProps {
  handleFilteredPoucts: Function;
  getAllProducts: Function;
}

const CategoryFilter = ({
  handleFilteredPoucts,
  getAllProducts,
}: ICategoryFilterProps) => {
  const [categoryHierarchy, setCategoryHierarchy] = useState<
    CategoryHierarchy[]
  >([]);
  const [childCategories, setChildCategories] = useState<CategoryHierarchy>();
  const [selectedChildCategory, setSelectedChildCategory] = useState<string[]>(
    []
  );
  const [showSelectedChildCategory, setShowSelectedChildCategory] = useState<
    string[]
  >([]);

  const [show, setShow] = useState(false);
  const { query } = useRouter();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    getCategoryHierarchy();
  }, []);

  useEffect(() => {
    if (categoryHierarchy) {
      setShowSelectedChildCategory([]);
      setSelectedChildCategory([]);
      categoryHierarchy.forEach((item: any) => {
        if (query.category == item?.slug) {
          setChildCategories(item);
          return item;
        }
      });
    }
  }, [query.category, categoryHierarchy]);
  const getCategoryHierarchy = async () => {
    try {
      const response = await apiCategories.getHierarchy();
      if (response) {
        setCategoryHierarchy(response);
      }
    } catch (err) {}
  };

  const handleSelectedCategory = (item: any, e: any) => {
    if (e.target.checked) {
      setSelectedChildCategory((prevVal) => [...prevVal, item.name]);
    } else {
      const getUnselectedCategory: string[] = [];
      const newUnselectedCategory = selectedChildCategory.filter((val) => {
        if (val !== item.name) {
          getUnselectedCategory.push(val);
        }
      });
      setSelectedChildCategory(getUnselectedCategory);
    }
  };

  const handleClickAway = () => {
    setShow(false);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setShow((prevVal) => !prevVal);
  };

  const removeFilteredCategory = (item: string) => {
    const newChildCategories = selectedChildCategory.filter((category) => {
      if (category !== item) {
        return category;
      }
    });

    setShowSelectedChildCategory(newChildCategories);
    setSelectedChildCategory(newChildCategories);

    const selctedCategory: string[] = [];
    const newCategory =
      childCategories &&
      childCategories.childCategories.filter((item) => {
        if (newChildCategories.indexOf(item.name) > -1) {
          selctedCategory.push(item.category);
        }
      });

    if (selctedCategory) {
      getProductByCategory(selctedCategory, false);
    } else {
      getAllProducts(selctedCategory);
    }
  };

  const addFilteredCategory = async () => {
    setShow((prevVal) => !prevVal);
    const selctedCategory: string[] = [];
    {
      const newCategory =
        childCategories &&
        childCategories.childCategories.filter((item) => {
          if (selectedChildCategory.indexOf(item.name) > -1) {
            selctedCategory.push(item.category);
          }
        });
    }
    if (selctedCategory) {
      getProductByCategory(selctedCategory, true);
    }
  };

  const getProductByCategory = async (
    slug: string | string[],
    applyFilter: boolean
  ) => {
    if (applyFilter) {
      setShowSelectedChildCategory(selectedChildCategory);
    }
    setShow(false);
    handleFilteredPoucts(slug);
  };

  return (
    <>
      {/* BREADCRUMB ADDED HERE */}
      <CategoryBreadcrumb category={query?.category as string} />
      <StyledCategoryFilterContainer>
        {/* <Typography variant="subtitle1" sx={{ textTransform: "capitalize" }}>
          {query.category}
        </Typography> */}
        <StyledHeadingWithGradientunderline
          variant="h1"
          sx={{
            fontSize: { sm: "1.5rem", xs: "1.2rem" },
            letterSpacing: "-1px",
          }}
        >
          {childCategories?.name}
        </StyledHeadingWithGradientunderline>
        <Box style={{ display: "flex" }}>
          {!isMobile && (
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {showSelectedChildCategory &&
                showSelectedChildCategory.map((item, index) => {
                  return (
                    <StyledGrayBox key={index}>
                      <span> {item}</span>
                      <Icon
                        component={ClearIcon}
                        style={{ fontSize: "1rem", marginLeft: "10px" }}
                        onClick={() => removeFilteredCategory(item)}
                      />
                    </StyledGrayBox>
                  );
                })}
            </div>
          )}
          <ClickAwayListener onClickAway={handleClickAway}>
            <FilterContainer>
              {childCategories && childCategories.childCategories.length > 0 && (
                <>
                  <Button
                    variant="outlined"
                    onClick={handleClick}
                    sx={{ display: { sm: "flex", xs: "none" } }}
                  >
                    <Icon
                      component={FilterAltIcon}
                      sx={{ cursor: "pointer" }}
                    />
                    Filter
                  </Button>
                  <Button
                    variant="text"
                    onClick={handleClick}
                    sx={{
                      display: { sm: "none", xs: "block" },
                      minWidth: "0px",
                    }}
                  >
                    <Icon
                      component={FilterAltIcon}
                      sx={{ cursor: "pointer" }}
                    />
                  </Button>
                </>
              )}
              {show && (
                <div
                  style={{
                    position: "absolute",
                    top: "3rem",
                    zIndex: "1000",
                    right: "0",
                  }}
                >
                  <DropDownContainer sx={{ boxShadow: 2 }}>
                    {childCategories &&
                      childCategories.childCategories.map((item) => {
                        return (
                          <MenuItem
                            key={item._id}
                            value={item.name}
                            style={{
                              wordBreak: "break-all",
                              padding: "5px",
                            }}
                          >
                            <Checkbox
                              name={item?.name}
                              onChange={(e) => {
                                handleSelectedCategory(item, e);
                              }}
                              value={selectedChildCategory}
                              defaultChecked={
                                selectedChildCategory.indexOf(item.name) > -1
                              }
                            />
                            <ListItemText
                              primary={item.name}
                              style={{
                                wordBreak: "break-all",
                                textTransform: "capitalize",
                                paddingRight: "9px",
                              }}
                            />
                            <br />
                          </MenuItem>
                        );
                      })}
                  </DropDownContainer>
                  <StyledLightGreenButton
                    sx={{
                      position: "absolute",
                      boxShadow: 2,
                      height: "2rem",
                      left: "0",
                      right: "0",
                    }}
                    fullWidth
                    onClick={addFilteredCategory}
                  >
                    Apply
                  </StyledLightGreenButton>
                </div>
              )}
            </FilterContainer>
          </ClickAwayListener>
        </Box>
      </StyledCategoryFilterContainer>
      {isMobile && (
        <Box style={{ display: "flex", flexWrap: "wrap" }}>
          {showSelectedChildCategory &&
            showSelectedChildCategory.map((item, index) => {
              return (
                <StyledGrayBox key={index}>
                  <span> {item}</span>
                  <Icon
                    component={ClearIcon}
                    style={{ fontSize: "1rem", marginLeft: "10px" }}
                    onClick={() => removeFilteredCategory(item)}
                  />
                </StyledGrayBox>
              );
            })}
        </Box>
      )}
    </>
  );
};
export default CategoryFilter;
